import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "./ui/card";

function ProjectItem({ image, name, id, tools }) {
  return (
    <Link
      to={`/project/${id}`}
      aria-label={`View project: ${name}`}
      className="group rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Card className="h-full overflow-hidden transition-colors group-hover:border-primary/60">
        <div
          className="h-40 w-full bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
          role="img"
          aria-label={name}
        />
        <CardContent className="p-4">
          <h2 className="text-base font-semibold leading-snug">{name}</h2>
          {tools && (
            <p className="mt-1 truncate font-mono text-xs text-muted-foreground">{tools}</p>
          )}
        </CardContent>
      </Card>
    </Link>
  );
}

export default ProjectItem;
